import React from "react";
import PropTypes from "prop-types";
import Options from "./Options";

export default class LocationSearch extends React.PureComponent{

    static propTypes = {
        language: PropTypes.string,
        onChange: PropTypes.func,
        locations: PropTypes.array,
        value: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <select
                className="search-select form-control form-control-lg col-12 custom-select"
                onChange={this.props.onChange}
                value={this.props.value}>
                <Options
                    options={this.props.locations}
                    language={this.props.language}
                    name={"Location"}
                    blankOption={true}
                />
            </select>
        )
    }
}
